<template>
  <div class="page-container">
    <van-nav-bar title="转赠详情" left-text="返回" left-arrow @click-left="$router.back()" />

    <div class="card info">
      <div class="title">转赠信息</div>
      <p>转赠名称：包钢福礼云购体验金</p>
      <p>转赠编号：{{ detail.code }}</p>
      <p>转赠额度：{{ detail.rebate }}</p>
      <p>转赠类型：{{ typeText[type] }}</p>
      <p>转赠状态：{{ statsText[detail.status] }}</p>
      <p v-if="type === 1">转赠发起时间：{{ detail.created_at | formatDate }}</p>
      <template v-if="detail.status === 2">
        <p v-if="type === 1">领取帐号：{{ detail.gift_get }}</p>
        <p >领取时间：{{ detail.created_get }}</p>
      </template>
      <p v-if="detail.status === 3">失败原因：转赠人撤销了转赠</p>
    </div>

    <div class="card qrcode" v-if="detail.status === 1">
      <div class="title">领取体验金二维码已生成</div>
      <div class="tips">
        点击<b>“分享”</b> ，以海报形式发送给朋友领取，或出示二维码让<br>朋友扫码领取。
      </div>
      <div class="image">
        <img :src="qrcodeUrl" alt="">
      </div>
      <button class="btn" @click="onShare">分享</button>
    </div>

    <div class="footer">
      <button class="btn back" @click="$router.back()">返回</button>
      <button class="btn" v-if="detail.status === 1" @click="handleRetreat">撤销转赠</button>
    </div>

    <popup-message ref="PopupMessageRef"></popup-message>
  </div>
</template>

<script>
import mixin from './mixin/index'
import dayjs from 'dayjs'

import { NavBar } from 'vant'
import PopupMessage from './components/PopupMessage.vue'

export default {
  name: 'EGDetail',
  mixins: [mixin],
  components: {
    VanNavBar: NavBar,
    PopupMessage
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  async created () {},
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    handleRetreat () {
      this.$refs.PopupMessageRef.open({
        title: '撤销转赠',
        message: '确定要撤销转赠吗？',
        confirmFn: async (done) => {
          this.onRetreat()
        }
      })
    },
    async onRetreat () {
      this.$toast.loading()
      const payload = {
        code: this.code
      }
      const res = await this.$axios.post('api/member/account_experience_gift_ref', payload)
      this.$toast.clear()
      const { code, msg } = res.data
      if (code === 0) {
        this.$refs.PopupMessageRef.open({
          title: '撤销成功',
          message: '撤销成功，转赠体验金将退回您的帐户。',
          cancelShow: false
        })
        this.fetchDetail()
      } else {
        this.$refs.PopupMessageRef.open({
          title: '撤销失败',
          message: msg,
          cancelShow: false
        })
      }
    },
    onShare () {
      this.$router.push({ name: 'EGShare', query: { code: this.detail.code, type: this.type } })
    }
  }
}
</script>

<style lang="less" scoped>
@main_color: #D9A47B;
@tabs_height: 0.82rem;

* {
  box-sizing: border-box;
}

.page-container {

  /deep/ .van-nav-bar  {
    .van-nav-bar__text {
      color: #404040;
    }
    .van-icon {
      color: #b2b2b2;
    }
  }

  .card {
    background: #FFFFFF;
    margin: 0.24rem;
    border-radius: 0.10rem;

    &.info {
      padding: 0.12rem 0.36rem 0.30rem;
      font-size: 0.24rem;
      color: #565656;
      position: relative;

      p {
        line-height: 2em;
      }

      .title {
        margin-bottom: 0.16rem;
        font-size: 0.28rem;
        font-weight: bold;
        color: #404040;

        &:before {
          content: ' ';
          width: 0.07rem;
          height: 0.20rem;
          background: #FF9346;
          position: absolute;
          top: 0.20rem;
          left: 0.12rem;
        }
      }
    }

    &.qrcode {
      padding: 0.28rem 0.20rem 0.40rem;
      .title {
        font-size: 0.28rem;
        color: #FF5353;
        text-align: center;
      }
      .tips {
        margin-top: 0.20rem;
        font-size: 0.22rem;
        color: #565656;
        text-align: center;
      }
      .image {
        width: 3.30rem;
        height: 3.30rem;
        margin: 0.35rem auto 0;
      }
      .btn {
        display: block;
        width: 1.80rem;
        height: 0.64rem;
        background: #46A9FF;
        margin: 0.35rem auto 0;
        border-radius: 999rem;
        font-size: 0.26rem;
        color: #FFFFFF;
      }
    }
  }

  .footer {
    margin-top: 0.46rem;
    .flex-center;

    .btn {
      width: 2.00rem;
      height: 0.74rem;
      border-radius: 999rem;
      border: 0.01rem solid #B1B1B1;
      font-size: 0.26rem;
      color: #515151;

      & + .btn {
        margin-left: 0.60rem;
      }

      &.back {
        border-color: #46A9FF;
        color: #46A9FF;
      }
    }
  }
}
.give-content {
  width: 100%;
  margin: 0.06rem 0 0.18rem;
  font-size: 0.22rem;
  color: #545454;
  .form-item {
    margin-bottom: 0.25rem;
    .flex-between;

    .inp {
      width: 4.10rem;
      height: 0.54rem;
      background: #FFFFFF;
      padding: 0 0.16rem;
      border-radius: 0.10rem;
      border: 0.01rem solid #979797;
      &::placeholder {
        font-size: 0.22rem;
        color: #B1B1B1;
      }
    }
  }
}
</style>
